module.exports = __webpack_public_path__ + "img/a639dd7.png";